import React from "react";
import MarketingProductSection from "./MarketingProductSection";
import MarketingLineupPreview from "./MarketingLineupPreview";

const MarketingLineupSection = ({ onStart }) => (
  <MarketingProductSection
    tone="paper"
    chip="Lineups · NBA, MLB, NFL"
    title="Build the lineup you’d actually run"
    body="The same field you get in the app — NBA, then MLB, then the NFL field. Tap a spot and start filling it in."
    ctaLabel="Build a Lineup"
    onCta={onStart}
  >
    <MarketingLineupPreview onInteract={onStart} />
  </MarketingProductSection>
);

export default MarketingLineupSection;
